// extracted by mini-css-extract-plugin
export default {"pager":"styles__pager___ZkRHq"};